import React, { useEffect } from 'react';

import store from 'store';
import { Row } from '../Basic';
import { Loader } from '../Loader';
import { showNotification } from 'actions/ui';
import { NotificationTypes } from 'constants';

const PADDING_SIZE = {
	l: '50px 0',
	m: '20px 0',
	s: '10px 0',
};

export const responseError = ({ type = NotificationTypes.HTTP_ERROR, ...options }) => {
	store.dispatch(showNotification({
		type,
		options: {
			message: options?.message || options?.error || 'Помилка виконання запиту ...',
			...options,
		},
	}));
};

export const FetchFallback = ({ isLoading, isFetching, isError, data, children, size = 'l' }) => {
	// useEffect(() => {
	// 	if (isError) {
	// 		responseError({
	// 			type: NotificationTypes.HTTP_ERROR,
	// 			...data,
	// 		});
	// 	}
	// }, [isError]);

	if (isLoading || isFetching) {
		return (
			<Row
				isAuto
				justifyContent="center"
				alignItems="center"
				padding={PADDING_SIZE[size]}
			>
				<Loader size={size} />
			</Row>
		);
	}

	if (isError) {
		return (
			<Row
				isAuto
				justifyContent="center"
				alignItems="center"
				padding={PADDING_SIZE[size]}
			>
				{data?.message || data?.error || 'Error ...'}
			</Row>
		);
	}

	if (data) {
		return children;
	}

	return (
		<Row
			isAuto
			justifyContent="center"
			alignItems="center"
			padding="50px 0"
		>
			Немає даних
		</Row>
	);
};
